var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PICTOS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2{fill:#EA650D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.2,20.1c-1,0-1.9-0.4-2.6-1.1s-1.1-1.6-1.1-2.6s0.4-1.9,1.1-2.6l9-9c1.9-1.9,5-1.9,7,0s1.9,5,0,7L14.3,17 c-0.2,0.2-0.6,0.2-0.8,0c-0.2-0.2-0.2-0.6,0-0.8l5.3-5.3c1.5-1.5,1.5-3.8,0-5.3c-1.5-1.5-3.8-1.5-5.3,0l-9,9 c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.7,0.3,1.3,0.7,1.8c1,1,2.6,1,3.6,0L17,9.1c0.3-0.3,0.4-0.6,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9 c-0.5-0.5-1.4-0.5-1.9,0l-5.6,5.6C9.4,13,9,13,8.8,12.8c-0.2-0.2-0.2-0.6,0-0.8l5.6-5.6c1-1,2.6-1,3.6,0c0.5,0.5,0.7,1.1,0.7,1.8 s-0.3,1.3-0.7,1.8L8.8,19C8.1,19.7,7.2,20.1,6.2,20.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.7ebb0e563208f5e0821a5691426b6f46.svg";
export { ForwardRef as ReactComponent };